var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.7125 0 0 6.65288 0 14.8668C0 21.4453 4.29375 27.0018 10.2562 28.9716C11.0062 29.1017 11.2875 28.6557 11.2875 28.2654C11.2875 27.9123 11.2688 26.7416 11.2688 25.4965C7.5 26.1841 6.525 24.5859 6.225 23.7496C6.05625 23.3222 5.325 22.0028 4.6875 21.6497C4.1625 21.371 3.4125 20.6834 4.66875 20.6648C5.85 20.6462 6.69375 21.7426 6.975 22.1886C8.325 24.4372 10.4813 23.8054 11.3438 23.4151C11.475 22.4488 11.8687 21.7984 12.3 21.4267C8.9625 21.055 5.475 19.7728 5.475 14.0863C5.475 12.4695 6.05625 11.1315 7.0125 10.0908C6.8625 9.71914 6.3375 8.1953 7.1625 6.15112C7.1625 6.15112 8.41875 5.76087 11.2875 7.67497C12.4875 7.34046 13.7625 7.17321 15.0375 7.17321C16.3125 7.17321 17.5875 7.34046 18.7875 7.67497C21.6563 5.74229 22.9125 6.15112 22.9125 6.15112C23.7375 8.1953 23.2125 9.71914 23.0625 10.0908C24.0188 11.1315 24.6 12.4509 24.6 14.0863C24.6 19.7914 21.0938 21.055 17.7563 21.4267C18.3 21.8913 18.7688 22.7833 18.7688 24.1771C18.7688 26.1655 18.75 27.7637 18.75 28.2654C18.75 28.6557 19.0313 29.1203 19.7813 28.9716C25.7063 27.0018 30 21.4267 30 14.8668C30 6.65288 23.2875 0 15 0Z",
    fill: "#006CEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.75L13.2 22.6L15 20.44H17.77L15.97 22.6L17.77 24.75H15ZM22.3907 16.45L19.7407 27.98H17.6107L20.2707 16.45H22.3907ZM22.1648 20.44H24.9348L26.7348 22.6L24.9348 24.75H22.1648L23.9648 22.6L22.1648 20.44Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubFront);
export default __webpack_public_path__ + "static/media/github-front.50d816270050241f67b5482980cf0f2e.svg";
export { ForwardRef as ReactComponent };